import { IBaseAction } from '../../constants';

export interface FlightsByFlightNumberState {
    data: {
        rpl: any;
        id: string;
    };
    error?: any
}

export interface FlightsInitialState {
    rpl: any;
    id: string;
}

export const GET_FLIGHTS_BY_FLIGHT_NUMBER = 'GET_FLIGHTS_BY_FLIGHT_NUMBER';
export const GET_FLIGHTS_BY_FLIGHT_NUMBER_SUCCESS = 'GET_FLIGHTS_BY_FLIGHT_NUMBER_SUCCESS';
export const GET_FLIGHTS_BY_FLIGHT_NUMBER_CLEAR = 'GET_FLIGHTS_BY_FLIGHT_NUMBER_CLEAR';
export const GET_FLIGHTS_BY_FLIGHT_NUMBER_FAILURE = 'GET_FLIGHTS_BY_FLIGHT_NUMBER_FAILURE';
interface GetFlightsByFlightNumberList extends IBaseAction {
    type: typeof GET_FLIGHTS_BY_FLIGHT_NUMBER | typeof GET_FLIGHTS_BY_FLIGHT_NUMBER_SUCCESS | typeof GET_FLIGHTS_BY_FLIGHT_NUMBER_CLEAR | typeof GET_FLIGHTS_BY_FLIGHT_NUMBER_FAILURE;
    payload: {
        data: FlightsInitialState;
        error?: any;
    };
}

export interface CancelFlightRequestState {
    data: {
        result: Boolean
    };
    error?: {
        reason: string;
    }
}

export interface CancelFlightRequestInitialState {
    result: Boolean
}
export interface CancelFlightRequestErrorState {
    reason: string;
}
export const CANCEL_FLIGHT_REQUEST = 'CANCEL_FLIGHT_REQUEST';
export const CANCEL_FLIGHT_REQUEST_SUCCESS = 'CANCEL_FLIGHT_REQUEST_SUCCESS';
export const CANCEL_FLIGHT_REQUEST_CLEAR = 'CANCEL_FLIGHT_REQUEST_CLEAR';
export const CANCEL_FLIGHT_REQUEST_FAILURE = 'CANCEL_FLIGHT_REQUEST_FAILURE';
interface CancelFlightRequestList extends IBaseAction {
    type: typeof CANCEL_FLIGHT_REQUEST | typeof CANCEL_FLIGHT_REQUEST_SUCCESS | typeof CANCEL_FLIGHT_REQUEST_CLEAR | typeof CANCEL_FLIGHT_REQUEST_FAILURE;
    payload: {
        data: CancelFlightRequestInitialState;
        error?: CancelFlightRequestErrorState;
    };
}

export type CancelFlightsActionTypes = GetFlightsByFlightNumberList | CancelFlightRequestList